import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-action-details',
  templateUrl: './action-details.component.html',
  styleUrls: ['./action-details.component.scss']
})
export class ActionDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
